// ─── «НЕ ЗАПИСАНЫ (УВОЛЕНЫ)»: КЛЮЧИ ОТВЕТА ДОСКИ → ИМЕНА ─────────────────────
// 03.10 (владелец: «продолжи» — старая доска молча теряла уволенных). POST /api/assignments/bulk
// (apps/api/src/routes/assignments.ts, bulkAssign) пропускает уволенных и отвечает fired: ключи
//   "<bookingId>_<operatorId>"           — игра;
//   "hall:<branchId>:<operatorId>"       — админ зала;
//   "mc:<bookingId>_<mcId>_<operatorId>" — мастер-класс.
// bookingId — число, branchId — без «:», поэтому игра и зал режутся точно. id сотрудника сам
// бывает с «_» (staff_lx3…), а у МК между броней и сотрудником ещё mcId — там ищем известный
// id в хвосте ключа (самый длинный), без совпадения — хвост после последнего «_».

export interface NamedOperator { id: string; name: string }

/** id сотрудника из ключа fired (см. форматы выше). */
export function firedOperatorId(key: string, knownIds: readonly string[]): string {
  if (key.startsWith("hall:")) return key.split(":").slice(2).join(":");
  if (!key.startsWith("mc:")) return key.slice(key.indexOf("_") + 1);
  let best = "";
  for (const id of knownIds) if (id.length > best.length && key.endsWith(`_${id}`)) best = id;
  return best || key.slice(key.lastIndexOf("_") + 1);
}

/**
 * Плашка доски: «Не записаны (уволены): Имя, Имя — пересоберите расстановку».
 * Каждый человек — один раз, сколько бы его игр ни пропало; кого нет в списке доски —
 * «сотрудник» (несколько — «сотрудники (N)»). Пусто — null.
 */
export function firedNotice(keys: readonly unknown[] | null | undefined, operators: readonly NamedOperator[]): string | null {
  const list = (keys ?? []).filter((k): k is string => typeof k === "string" && k.length > 0);
  if (!list.length) return null;
  const byId = new Map(operators.map((o) => [o.id, o.name]));
  const ids = [...new Set(list.map((k) => firedOperatorId(k, [...byId.keys()])))];
  const names = ids.map((id) => byId.get(id)).filter((n): n is string => !!n);
  const unknown = ids.length - names.length;
  if (unknown === 1) names.push("сотрудник");
  else if (unknown > 1) names.push(`сотрудники (${unknown})`);
  return `Не записаны (уволены): ${names.join(", ")} — пересоберите расстановку`;
}

/**
 * Архив 1С (14.10): POST /api/assignments/bulk не трогает пары игр 1С и МК-пары их броней — пропускает и отвечает
 * game1c_skipped (ключи — в тех же форматах «бронь_сотрудник» / «mc:бронь_мк_сотрудник»). Плашка доски — одной строкой
 * рядом с «Не записаны (уволены)». Ключ — одна пара, сколько бы раз он ни пришёл. Пусто — null.
 */
export function game1cNotice(keys: readonly unknown[] | null | undefined): string | null {
  const n = new Set((keys ?? []).filter((k): k is string => typeof k === "string" && k.length > 0)).size;
  return n ? `Игры 1С не меняются: ${n} пар не сохранены` : null;
}
